module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header\"><span class=\"prop-label\">Row Settings</span></div>\r\n<div class=\"nav-position prop-detail\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-3 prop-sublabel\">Height</div>\r\n        <div class=\"col-md-3 nopadding\">\r\n            <input type=\"text\" value=\"")
    ; __append(escapeFn(rowHeight))
    ; __append("\" name=\"rowHeight\" class=\"inputTextWithLabel\" maxlength=\"2\"/>\r\n            <span style=\"padding-left: 3px;\">px</span></div>\r\n        <div class=\"col-md-2 prop-sublabel nopadding-r\" style=\"padding-left: 5px!important;\">Max</div>\r\n        <div class=\"col-md-3 nopadding\"><input type=\"text\" value=\"")
    ; __append(escapeFn(maxRows))
    ; __append("\" name=\"maxRows\" maxlength=\"6\" /></div>\r\n    </div>\r\n</div>")
  }
  return __output;

}